import { Redirect, Route, Switch } from "react-router-dom";
import { getPath } from "common/routing";
import { useGetCurrentPublicUserQuery } from "../../generated/graphql";
import { GuestPasswordReset } from "../Authentication/PasswordReset/GuestPasswordReset";
import { ConfirmEmailSignup } from "../Authentication/Public/ConfirmEmailAddress";
import { RequestEmailConfirmation } from "../Authentication/Public/RequestEmailConfirmationCode";
import GuestAuthContextProvider from "../Authorization/GuestAuthContext";
import { DetailView } from "../DocumentUploads/DetailView";
import Map from "../Maps";
import CreateSubmissionContainer from "../Submissions/CreateSubmission";
import EditSubmission from "../Submissions/EditSubmission";
import SubmissionSummary from "../Submissions/SubmissionSummary";
import ViewSubmission from "../Submissions/ViewSubmission";
import AccessDeniedPage, { ACCESS_DENIED_RESOURCE } from "./AccessDeniedPage";
import { withPublicUserAuth } from "./Authorization/withPublicUserAuth";
import CustomObjectPage from "./CustomObject";
import CertificatesPage from "./ElevationCertificates";
import UploadElevationCertificatesPage from "./ElevationCertificates/UploadElevationCertificates";
import GetHelpPage from "./GetHelp";
import GuestPropertySearch from "./index";
import MyRecords from "./MyRecords/MyRecords";
import NoPropertyPage from "./NoPropertyPage";
import ResidentPropertyPage from "./Property";
import PropertyRedirect from "./PropertyRedirect";
import SavedView from "./SavedView";
import { ListWorkflows } from "./Workflows/ListWorkflows";
import { Workflow } from "./Workflows/Workflow";
import { WorkflowDefinition } from "./Workflows/WorkflowDefinition";

export const MainRoutes = () => {
  const {
    data: currentPublicUserData,
    loading: loadingAuthorizedEntity,
    refetch: refetchAuthorizedEntity,
  } = useGetCurrentPublicUserQuery({});

  const props = {
    publicUser: currentPublicUserData?.currentPublicUser,
    loadingAuthorizedEntity,
    refetchAuthorizedEntity,
  };

  return (
    <Switch>
      <GuestAuthContextProvider {...props}>
        <Switch>
          <Route
            path={getPath("guestUploadElevationCertificates")}
            component={UploadElevationCertificatesPage}
          />
          <Route
            path={getPath("guestElevationCertificates")}
            component={CertificatesPage}
          />
          <Route
            path={getPath("guestDocumentUploadDetail")}
            component={DetailView}
          />
          <Route
            // if we have gotten to this route, the middleware has not found a file
            // therefore we should always return an access denied page
            path={getPath("guestDocumentUploadFile")}
            render={() => (
              <AccessDeniedPage resource={ACCESS_DENIED_RESOURCE.FILE} />
            )}
          />
          <Route path={getPath("getHelp")} component={GetHelpPage} />
          <Route path={getPath("noProperty")} component={NoPropertyPage} />
          <Route
            path={getPath("residentCustomObject")}
            component={CustomObjectPage}
          />
          <Route
            path={getPath("residentProperty")}
            component={ResidentPropertyPage}
          />
          <Route
            path={getPath("residentPropertyRedirect")}
            component={PropertyRedirect}
          />
          <Route
            exact
            path={getPath("guestHome")}
            component={GuestPropertySearch}
          />
          <Route path={getPath("explore")} component={Map} />
          <Route
            path={getPath("createSubmission")}
            component={CreateSubmissionContainer}
          />
          <Route
            path={getPath("submissionSummary")}
            component={SubmissionSummary}
          />
          <Route path={getPath("editSubmission")} component={EditSubmission} />
          <Route path={getPath("viewSubmission")} component={ViewSubmission} />
          <Route path={getPath("residentSavedView")} component={SavedView} />
          <Route
            path={getPath("workflowDefinition")}
            component={WorkflowDefinition}
          />
          <Route
            path={getPath("listWorkflows")}
            component={withPublicUserAuth(
              ListWorkflows,
              ACCESS_DENIED_RESOURCE.WORKFLOW,
            )}
          />
          <Route
            path={getPath("workflow")}
            component={withPublicUserAuth(
              Workflow,
              ACCESS_DENIED_RESOURCE.WORKFLOW,
            )}
          />
          <Route
            path={getPath("myRecords")}
            component={withPublicUserAuth(
              MyRecords,
              ACCESS_DENIED_RESOURCE.PAGE,
            )}
          />
          <Redirect exact from="/my-submissions" to="/my-records" />
          <Route
            path={getPath("signupConfirmation")}
            component={ConfirmEmailSignup}
          />
          <Route
            path={getPath("requestEmailConfirmation")}
            component={RequestEmailConfirmation}
          />
          <Route
            path={getPath("passwordResetRequest")}
            component={GuestPasswordReset}
          />
        </Switch>
      </GuestAuthContextProvider>
    </Switch>
  );
};
